import {
  EyeOutlined,
  LoadingOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import styled from "@emotion/styled";
import { Tooltip } from "antd";
import downImg from "../../assets/vertical_align_bottom.png";

const CardHeader = ({
  title,
  tooltipTitle,
  subtitle,
  selectedCards = [],
  onEyeClick,
  downloading = false,
  onDownloadClick,
}) => {
  return (
    <div className="d-flex align-items-start justify-content-between flex-wrap gap-2">
      <div className="section-title d-flex flex-wrap align-items-start justify-content-between gap-2">
        <p className="section-title-text">
          {title}
          {tooltipTitle && (
            <Tooltip title={tooltipTitle}>
              <QuestionCircleOutlined
                style={{
                  color: "#8A94A6",
                  fontSize: "0.85rem",
                }}
              />
            </Tooltip>
          )}
        </p>
        <p className="section-title-subtext">{subtitle}</p>
      </div>

      <div className="section-header-actions" style={{ gap: "1rem" }}>
        {selectedCards.length > 0 && (
          <ChipList>
            {selectedCards.map((c) => (
              <Chip key={c.id} color={c.color}>
                {c.name}
              </Chip>
            ))}
          </ChipList>
        )}
        <PickerActionsRow className="no-print p-0">
          {onEyeClick && (
            <Tooltip title="View all sections" placement="top">
              <div className="improvementRight ms-auto d-flex justify-content-center align-items-center">
                <div onClick={onEyeClick} className="downIcon">
                  <EyeOutlined size={"large"} />
                </div>
              </div>
            </Tooltip>
          )}
          {onDownloadClick && (
            <Tooltip placement="top" title="Download improvement areas">
              <div className="improvementRight ms-auto d-flex justify-content-center align-items-center">
                <div
                  onClick={onDownloadClick}
                  className="downIcon"
                  style={{ cursor: `${downloading ? "normal" : "pointer"}` }}
                >
                  {downloading ? (
                    <LoadingOutlined spin />
                  ) : (
                    <img src={downImg} alt="img" />
                  )}
                </div>
              </div>
            </Tooltip>
          )}
        </PickerActionsRow>
      </div>
    </div>
  );
};

const PickerActionsRow = styled.div`
  display: flex;
  align-items: stretch;
  gap: 8px;
`;

const ChipList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
`;

const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: ${(props) => `${props.color}1A`};
  color: ${(props) => props.color};
  border: 1px solid ${(props) => `${props.color}55`};
  border-radius: 999px;
  padding: 0.3rem 0.7rem;
  font-size: 0.8rem;
  font-weight: 600;
`;

export default CardHeader;
